import * as React from "react";
import { Gapped, Link } from "react-ui";
import areEqual from "fbjs/lib/areEqual";

import { declint } from "../../../../Engine/utils";
import { FILTER_RESET } from "../../../metricsAction";
import { trackAction } from "../../../Internals/Metrics/MetricsProvider";
import { nullElement, pullContext } from "../../../TypingUtils";
import { MultiLineFilter } from "../../MultiLine/MultiLineFilter";
import { AbsoluteModelPath } from "../../../../../../Common/ModelPath/ModelPath";
import { tablePathContextTypes } from "../../CrossfitTable/TablePathContext";

import { Root } from "./FilterInfo.styles";

export interface FilterInfoProps {
    filters: MultiLineFilter[] | undefined;
    filtered: boolean;
    foundInstancesCount: number;
    filteringResultVersion: number;
    multilinePath: AbsoluteModelPath;
    notFoundText?: string;
    resetFilters: (stickyTablePath: string) => void;
    titles: [string, string, string];
    instancesCount: number;
}

interface FilterInfoContext {
    stickyTablePath: string;
}

export class FilterInfo extends React.Component<FilterInfoProps> {
    public static contextTypes = tablePathContextTypes;

    public shouldComponentUpdate(nextProps: FilterInfoProps): boolean {
        // NOTE Это тут для того, чтобы текстовка о кол-ве найденных менялась
        // только когда фильтры изменились, но не менялась если данные меняются пользователем
        return (
            !areEqual(this.props.filters, nextProps.filters) ||
            !areEqual(this.props.filteringResultVersion, nextProps.filteringResultVersion)
        );
    }

    public render(): JSX.Element | null {
        const { foundInstancesCount, instancesCount, titles, filtered } = this.props;

        if (filtered) {
            const foundInstancesText = foundInstancesCount
                ? `${declint(foundInstancesCount, ["Найден", "Найдено", "Найдено"])} ${declint(
                      foundInstancesCount,
                      titles.map(title => `%s ${title}`) as [string, string, string]
                  )} из ${instancesCount}`
                : this.props.notFoundText;
            return (
                <Root>
                    <Gapped gap={20}>
                        <span data-tid="FoundInstancesText">{foundInstancesText}</span>
                        <Link data-tid="FilterReset" onClick={this.handleOnClickReset}>
                            Сбросить фильтры
                        </Link>
                    </Gapped>
                </Root>
            );
        }

        return nullElement;
    }

    private readonly handleOnClickReset = (): void => {
        setTimeout(() => this.runResetFilters(), 500);
    };

    @trackAction(FILTER_RESET)
    private runResetFilters(): void {
        this.props.resetFilters(this.getContext().stickyTablePath);
    }

    private getContext(): FilterInfoContext {
        return pullContext<FilterInfoContext>(this);
    }
}
